import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import AppLayout from './app-layout'
import { NewGameForm } from './features/game'
import FindGameForm from './features/share/FindGameForm'
import Card from './ui/card'

export default function HomeRoute() {
    const history = useHistory()
    const handleFindGame = useCallback(gameId => history.push(`/g/${gameId}`), [history])

    return (
        <AppLayout>
            <>
                <Card title="Start a new game">
                    <div style={{padding: 16}}>
                        <p>You can start a new game to play with your friends and/or bots.</p>
                        <NewGameForm />
                    </div>
                </Card>
                <Card title="Join a game">
                    <div style={{padding: 16}}>
                        <p>If you have received a game code, you can enter it in the form below to join the game.</p>
                        <FindGameForm onFind={handleFindGame} />
                    </div>
                </Card>
            </>
        </AppLayout>
    )
}